import { render } from "./app-footer-sjb.vue?vue&type=template&id=69f2a564&scoped=true&ts=true"
import script from "./app-footer-sjb.vue?vue&type=script&lang=ts"
export * from "./app-footer-sjb.vue?vue&type=script&lang=ts"

import "./app-footer-sjb.vue?vue&type=style&index=0&id=69f2a564&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69f2a564"]])

export default __exports__